/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { SELECTED_SPONSOR } from '../../../constants/common';

class StudyInformationService {
  static navigateToUAT = (uatTenantId, allocations, uatNavigationFunc) => {
    const uatTenant = StudyInformationService.getTenantFromAllocations(uatTenantId, allocations);
    if (uatTenant) {
      uatNavigationFunc(uatTenant);
      sessionStorage.setItem(SELECTED_SPONSOR, JSON.stringify(uatTenant));
    }
  };

  static getTenantFromAllocations = (tenantId, allocations) => {
    return allocations.find((allocation) => allocation.id === tenantId);
  };

  /** ============= Utility method that gets given tenant from allocation  array  ======= */
  static getProductionTenantForUAT = (tenantName, allocations) => {
    let productionTenantName = tenantName.substring(0, tenantName.lastIndexOf('-TEST-'));
    return allocations.find((allocation) => allocation.sponsorname === productionTenantName);
  };

  static findAllocationByDatabaseName = (databaseName, allocations) => {
    return allocations.find((allocation) => (allocation.databasename = databaseName));
  };
}

export default StudyInformationService;
